import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./fonts/_fontfaces.scss"
import App from "./App"
import * as serviceWorker from "./serviceWorker"

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<StrictMode><App /></StrictMode>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
